import React from 'react';
import { Users, Code2, ShieldCheck, LineChart } from 'lucide-react';
export function WhyChoose() {
  const features = [{
    icon: <Users className="h-7 w-7 sm:h-8 sm:w-8 text-primary" data-id="element-392" />,
    title: 'Built by the Laravel Community',
    description: 'Crafted by certified developers who understand what skills truly matter.'
  }, {
    icon: <Code2 className="h-7 w-7 sm:h-8 sm:w-8 text-primary" data-id="element-393" />,
    title: 'Real-World Scenarios',
    description: 'Laravel 12 tasks based on real project use, not theoretical problems.'
  }, {
    icon: <ShieldCheck className="h-7 w-7 sm:h-8 sm:w-8 text-primary" data-id="element-394" />,
    title: 'Fair & Secure',
    description: 'Proctored assessments with randomized question pools and anti-cheat detection for reliable results.'
  }, {
    icon: <LineChart className="h-7 w-7 sm:h-8 sm:w-8 text-primary" data-id="element-395" />,
    title: 'Instant Insights',
    description: 'Auto-graded reports with skill breakdowns to make hiring decisions easier.'
  }];
  return <section id="why-choose" className="py-12 md:py-20 bg-white" data-id="element-396">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-397">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-3 sm:mb-4" data-id="element-398">
          Why Choose Our Laravel Recruitment Tests?
        </h2>
        <p className="text-center text-gray-600 mb-8 sm:mb-12 max-w-2xl mx-auto px-4" data-id="element-399">
          Our standardized assessment platform identifies top Laravel talent
          efficiently, fairly, and with full proctoring — so you can hire with
          confidence.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-400">
          {features.map((feature, index) => <div key={index} className="p-6 sm:p-8 rounded-xl border border-gray-200" data-id="element-401">
              <div className="mb-4 sm:mb-5 bg-gray-50 p-3 sm:p-4 inline-block rounded-full" data-id="element-402">
                {feature.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3" data-id="element-403">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600" data-id="element-404">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}